exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".footer{-ms-flex-align:center;align-items:center;-webkit-box-sizing:border-box;box-sizing:border-box;display:-ms-flexbox;display:flex;-ms-flex-pack:justify;justify-content:space-between;height:64px}.footer__navigation-ul{list-style-type:none;margin:0;padding:0}.footer__navigation-li{display:inline;margin-left:12px;margin-right:12px}@media (max-width:767px){.footer{-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:center;justify-content:center;text-align:center;height:128px;padding-left:12px;padding-right:12px}.footer__copyright{margin-bottom:12px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/Footer/Footer.scss
// module id = 765
// module chunks = 1 3 5